export default {
  menu: {
    index: 'Platform Template',
    works: 'My Creative',
    myTemplate: 'Private Template',
    stars: 'My Collection',
  },
  suggestionDialog: {
    title: 'Production Suggestions',
    context:
      '· Any Editing in Content editor is not limited.<br/>· Better not to delete the core layer or scenes related to the gameplay logic, they may affect the playabilities.<br/>· Preview to check before the exportation.',
  },
  saveAsTemplate: {
    label: 'Save As Template',
    cancel: 'Cancel',
    confirm: 'Confirm',
    form: {
      nameLabel: 'Template Name',
      name: 'Please input the template name',
      emptyName: 'Template name cannot be empty',
      overName: 'No more than 50 characters.',
    },
    copy: 'Copy',
    rename: 'Rename',
    success: 'Template saved successfully',
  },
  previewDialog: {
    next: 'Next',
    prev: 'Prev',
    create: 'Feature Creation',
    createTips:
      'Based on Playable Templates, replace assets, resize elements, and adjust gameplay parameters to quickly export high-quality playable ads.',
    free: 'Content Creation',
    freeTips:
      'Beyond Feature Creation, you can further tweak templates—like adjusting layouts, adding assets, or editing events—to create many versions.',
    qrcodeLabel: 'View on Mobile',
    skinLabel: 'Select Skin',
    difficulty: 'Difficulty Level',
    modelCount: 'Model count',
    actionCount: 'Num. of animations',
  },
  index: {
    listEmpty: 'No Results',
    listDesc:
      'Sorry, no eligible results were found. It is suggested to change to different search criteria.',
    saveListEmpty: 'There is no saved template',
    leaveMessage: {
      title: 'Leave a message',
      desc: ' to try out more templates',
    },
    checkall: 'See All',
    filters: {
      category: 'Types',
      classify: 'Category',
      industry: 'Industry',
      originality: 'Creativity',
      difficulty: 'Difficulty',
      playMethod: 'Method',
      productType: 'Product',
      all: 'All',
      new: 'Newest First',
      hot: 'Most Used',
      more: 'More',
      back: 'Fold',
    },
    list: {
      starButton: 'Favorite',
      useTemplate: 'Create',
      unsave: 'Unsave',
      saveSuccess: 'Successfully Saved',
    },
    estimated: 'Estimated time',
    createFromBlank: 'Blank Canvas',
  },
  works: {
    listEmpty: 'No Results',
    dcoStatus: 'Unpublished',
    listNormal:
      "You haven't created a project yet, choose a template and start creating now!",
    listMgroup:
      'Variant creation is an efficient method for creating works for AB test. You can add multiple assets to the position to be adjusted and download all at once (up to 27).',
    listDCO:
      'DCO creative is a production method that supports the ability of intelligent advertising. The creative produced can display different content for different audience. You can add alternative assets for each open positions, then apply the creative to your Mintegral campaign. Mintegral will select the best assets at each position according to the algorithm and combine them for a version to improve conversion.',
    infoTitle: 'My Creative',
    infoContent:
      'We support multi-combination and DCO creatives to facilitate rapid production and intelligent advertising.',
    psMgroup:
      "With simple 'drag and drop' PPT-style operations, without any coding, you can freely combine images, text, audio, video, and effects to create personalized playable.",
    ivMgroup:
      'No skills needed. With visual scripting, simply add trigger events on the video timeline to easily convert ordinary videos into interactive ones and quickly achieve interactive effects.',
    projectType: {
      normal: 'General Creation',
      normalEditor: 'Feature Changer',
      dco: 'DCO Editing',
      mgroup: 'Variant Creation',
      mgroupEditor: 'Variant Feature Changer',
      ps: 'Content Editor',
      iv: 'Video to Playable',
    },
    projectPlaceHolder: 'Creative name',
    table: {
      column: {
        name: 'Creatives',
        type: 'Type',
        template: 'Template Name',
        status: 'Status',
      },
    },
    status: {
      all: 'Status',
      making: 'Producing',
      downloaded: 'Downloaded',
      reviewing: 'Processing',
      pushed: 'Applied',
      pushFaild: 'Push Failed',
      pending: 'Applying',
      partSuccess: 'Partially Applied',
    },
    options: {
      edit: 'Edit',
      product: 'Edit Product Info',
    },
  },
  myTemplate: {
    menu: {
      update: 'Update',
      copy: 'Copy',
      delete: 'Delete',
      edit: 'Rename',
    },
    sort: {
      createdTimeNear: 'Creation time (Ascending)',
      createdTimeFar: 'Creation time (Descending)',
      updatedTimeNear: 'Update time (Ascending)',
      updatedTimeFar: 'Update time (Descending)',
    },
    sortOrder: {
      createdTime: 'Creation Time',
      updatedTimer: 'Updated Time',
    },
    status: {
      check: 'To be Checked',
      unauthorized: 'Unauthorized',
    },
  },
  subscribe: {
    renew: 'Renew',
    expired: 'Your subscription has expired.',
    hasNotSubscribe: "You haven't created a subscription yet.",
    timeLeft: 'Expires after {{timeLeft}} days',
    hasNotSubscribeAlertTitle:
      "You haven't created a subscription yet. Subscribe Now!",
    expiredAlertTitle: 'Your subscription has expired. Renew it now!',
    renewExpiredAlertTitle: 'Renew',
    alertDesc:
      'Please fill out the form below and we will respond to you shortly.',
    form: {
      name: {
        label: 'Name',
        placeholder: 'Please provide your name',
      },
      email: {
        label: 'Email',
        placeholder: 'Please provide your email address',
      },
      month: {
        label: 'Duration',
        placeholder: 'Duration',
        optionTail: 'Months',
      },
      remark: {
        label: 'Note',
        placeholder: "Other contact info or things you'd like to add",
      },
    },
    submitSuccess: {
      title:
        'Your renewal application has been sent, we will respond to you shortly',
      desc: 'If you have any other questions, please email to <a href="mailto:support@mindworks-creative.com">support@mindworks-creative.com</a>.',
    },
  },
  resetTemplate: {
    text: 'Restore Defaults',
    warnTitle: 'Are you sure to restore all the defaults?',
    warnDetail: 'All changes will be restored to the default.',
  },
  versionEditTitle: 'Edit Project Info',
  creativeInfo: {
    action: {
      create: 'Create',
      update: 'Update',
      copy: 'Copy',
    },
    type: {
      create: {
        normal: 'Feature Changer',
        mgroup: 'Variant Feature Changer',
        dco: 'DCO Editing',
        playsmart: 'Content Editing',
        createPlayable: 'Create creative',
        directCreate: 'Create from blank',
        psdCreate: 'Upload PSD',
        iv: 'Video to Playable',
      },
      copy: {
        normal: 'Copy',
        mgroup: 'Copy to Variant Feature Changer',
        dco: 'Copy to DCO',
        playsmart: 'Copy to Content Editor',
        iv: 'Copy to Interactive Video Editor',
      },
    },
    form: {
      versionName: {
        label: 'Version Name',
        placeholder: 'Please enter the version name',
        validateMessage:
          'Only can contain numbers, letters, underscore, and shorter than 50 characters.',
        empty: 'The Version Name cannot be empty.',
      },
      name: {
        label: 'Project Name',
        placeholderProject: 'Please input Project Name',
        placeholder:
          'Only can contain numbers, letters, underscore, and shorter than 50 characters.',
        validateMessage:
          'Only can contain numbers, letters, underscore, and shorter than 50 characters.',
        empty: 'The Project Name cannot be empty.',
      },
      promotedType: {
        label: 'Product Type',
        empty: 'The product type cannot be empty.',
      },
      appInfo: 'Promoted Product Information (CTA or Landing Page)',
      appIcon: {
        label: 'Icon',
        tips: 'The icon displayed is based on the provided link.',
      },
      appName: {
        label: 'Product Name',
        tips: 'The name displayed is based on the provided link.',
        empty: 'The Product Name cannot be empty.',
      },
      url: {
        label: 'Redirect URL',
        placeholder: 'URL.',
        empty: 'The redirect URL cannot be empty.',
        valid: 'Please verify the redirect URL is in a valid format',
      },
      iOSURL: {
        label: 'iOS URL',
        placeholder: 'Apple App Store URL.',
        empty: 'The redirect URL cannot be empty.',
      },
      androidURL: {
        label: 'Android URL',
        placeholder: 'Google Play/Android App Store URL.',
        empty: 'The redirect URL cannot be empty.',
      },
      platform: {
        label: 'Platform Type',
        empty: 'The platform cannot be empty.',
      },
      direction: {
        label: 'Adaptation Orientation',
        tips: 'The “Mintegral” channel needs to support both horizontal and vertical screens.',
        placeholder: 'Please select the adaptation direction',
        options: {
          adaptive: {
            label: 'Horizontal & Vertical screen',
            desc: 'Separate layouts are required for vertical and horizontal screens. Playable content will be displayed according to the screen orientation.',
            tips: 'Recommended for Mintegral',
          },
          landscape: {
            label: 'Landscape',
            desc: 'Design landscape layouts only. Zoom out when displayed on a vertical screen',
          },
          portrait: {
            label: 'Portrait',
            desc: 'Design portraits layouts only. Zoom out when displayed on a horizontal screen',
          },
          see: '. Find more information in the',
          help: 'Help Center',
        },
      },
      language: {
        label: 'Default Language',
        placeholder: 'Please select a default language',
        empty: 'The default  language cannot be empty.',
      },
      quality: {
        label: 'Quality',
        title: 'Quality Selection',
      },
      psd: {
        title:
          'Upload PSD (Adapt to horizontal and vertical screens by default)',
        uploadTip1: 'Drag and drop files here, or click to upload instantly',
        uploadTip2: 'Single file: upload 1 PSD file directly',
        uploadTip3:
          'Horizontal and vertical version: make the two PSD files into a zip package, and keep the files uploaded in the root directory',
        uploadTip4:
          'Image Compression: the image size does not change; the higher the percentage value, the higher the quality, the larger the file size',
        uploading: 'Uploading',
        error: 'Upload failed, please upload again',
        emptyError: 'The PSD file cannot be empty',
        psdError: 'The PSD file is incorrect',
        psdErrorName: 'The file name must be English, number, or underscore',
      },
      psd2uiErr: {
        firstLv: 'The first level of the layer groups can only be “game”',
        scenePlayGlobal:
          'The 1st level under “game” layer group needs to be “xxx@scene”, “xxx@global”, “xxx@play” in order',
        zip: 'The zip package must contain 2 PSD files',
        layerEmpty:
          'Horizontal and vertical version PSD: at least one layer is empty, please compare the difference between the horizontal and vertical versions! Vertical version: {layersPName}, horizontal version: {layersLName}',
        layerDiff:
          'The layer names of the horizontal and vertical versions of PSD are different, please compare the layers. Vertical version: {layersPName}, horizontal version: {layersLName}',
        emptyImg:
          'The layer was not loaded successfully, there is a non-pixel layer: {path} (It is recommended to replace the non-pixel layer with a solid color block, and then replace it with a transparent image later)',
        rasterized: 'Layer {path} needs rasterization to export images',
        validName:
          'The file name in the zip package must be English, number, or underscore',
      },
    },
  },
}
